import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{yield (hash onBlur=this.onBlur errors=this.errors)}}",{ moduleName: "my-phorest/components/ui/form/-error-propagator/index.hbs" })